import * as React from 'react';
import {Query} from 'react-apollo';

import type {MailChimpListsQuery as MailChimpListsQueryQuery} from 'nutshell-graphql-types';

import {GraphQLSelect} from './graphql-select';
import GET_MAILCHIMP_LISTS from './queries/mailChimpLists.graphql';

class MailchimpQuery extends Query<MailChimpListsQueryQuery, Record<any, any>> {}

type Props = {
    selectedId: string | null | undefined;
    onChange: (newValue: any) => any;
    onClearValue?: () => void;
    labelKey?: string;
    valueKey?: string;
    autoFocus?: boolean;
    autoBlur?: boolean;
    isLoading?: boolean;
    noResultsText?: string;
    styles?: any;
    menuPortalTarget?: HTMLElement;
    defaultsToFirstItem?: boolean;
};

export const GraphQLSelectMailChimp = (props: Props) => (
    <MailchimpQuery query={GET_MAILCHIMP_LISTS}>
        {({data, loading}) => {
            const mailChimpLists = data ? data.mailChimpLists : null;

            return (
                <GraphQLSelect
                    {...props}
                    isLoading={loading}
                    // @ts-expect-error
                    openMenuOnFocus={true}
                    placeholder='Search MailChimp lists…'
                    valueKey='id'
                    models={mailChimpLists || []}
                />
            );
        }}
    </MailchimpQuery>
);
